import { PaginatedUsers, User, UserRole } from '../../../../domain/users/models/User';
import { ProGPTPaginatedUsersDto, ProGPTUserDto } from '../dtos/responses/ProGPTUserResponseDto';

const toUserRole = (role: ProGPTUserDto['role']): UserRole => {
    switch (role) {
        case UserRole.Admin:
            return UserRole.Admin;
        case UserRole.Creator:
            return UserRole.Creator;
        case UserRole.RestrictedAccess:
            return UserRole.RestrictedAccess;
        default:
            return UserRole.Standard;
    }
};

const toDateString = (value: string | number | undefined): string => {
    if (!value) {
        return '';
    }

    if (typeof value === 'string') {
        return value;
    }

    const timestamp = new Date(value).getTime();
    return Number.isNaN(timestamp) ? '' : new Date(value).toISOString();
};

export const mapProGPTUserDtoToModel = (dto: ProGPTUserDto): User => ({
    id: dto.id,
    role: toUserRole(dto.role),
    pinnedAgents: dto.pinnedAgents ?? [],
    emailAddress: dto.emailAddress,
    loginAddress: dto.loginAddress,
    name: dto.name,
    adInfo: dto.adInfo,
    createdDate: toDateString(dto.createdDate),
    lastLoggedIn: toDateString(dto.lastLoggedIn),
    modifiedDate: toDateString(dto.modifiedDate),
});

export const mapProGPTPaginatedUsersDtoToModel = (dto: ProGPTPaginatedUsersDto): PaginatedUsers => ({
    items: dto.items.map(mapProGPTUserDtoToModel),
    pageNumber: dto.pageNumber,
    pageSize: dto.pageSize,
    totalRecords: dto.totalRecords,
});
